import React from 'react';
import { useQuery } from '@apollo/client/react';
import { USERS_QUERY } from '../graphql/queries';
import DataTable from '../components/DataTable';
import EmptyState from '../components/EmptyState';
import QueryError from '../components/QueryError';
import M3LinearProgress from '../components/M3Progress';

export default function UsersPage() {
  const { data, loading, error } = useQuery(USERS_QUERY);

  const columns = [
    { key: 'name', title: 'Name' },
    { key: 'email', title: 'Email' },
    { key: 'role', title: 'Role' },
    { key: 'active', title: 'Status', render: (v) => (v ? 'Active' : 'Inactive') },
    { key: 'createdAt', title: 'Created', render: (v) => new Date(v).toLocaleDateString() }
  ];

  if (error)
    return (
      <div className="page-content">
        <QueryError error={error} onRetry={() => window.location.reload()} />
      </div>
    );

  if (loading)
    return (
      <div className="page-content">
        <M3LinearProgress indeterminate />
      </div>
    );

  if (!data?.users?.length) {
    return (
      <div className="page-content">
        <EmptyState icon="people" title="No Users" message="No users found." />
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Users</h1>
      </div>
      <DataTable
        columns={columns}
        data={data.users}
        loading={loading}
        rowKey="id"
        emptyMessage="No users found"
      />
    </div>
  );
}
